/**
 * Parse a WebVTTSourceLabelBox from an IsoView
 *
 * @param view - The IsoView to read data from
 *
 * @returns A parsed WebVTTSourceLabelBox
 *
 * @group ISOBMFF
 *
 * @beta
 */
export function vlab(view) {
    return {
        sourceLabel: view.readUtf8(-1),
    };
}
;
//# sourceMappingURL=vlab.js.map